module.exports = __webpack_public_path__ + "img/activepic.8036e394.png";